// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RkO5","controls":"styles_controls__3flb8","charLimit":"styles_charLimit__2_C8U","input":"styles_input__P1rtw","send":"styles_send__1o5ie"};